import { Box, Flex, Text } from '@everlywell/ui-kit';
import React from 'react';

import type { BubbleProps } from '../types/components';

export default function ChatUserBubble({
  text,
  variant = 'page',
}: BubbleProps): JSX.Element {
  if (variant === 'widget') {
    return (
      <Box
        alignSelf="flex-end"
        backgroundColor="rgba(116, 41, 116, 0.08)"
        borderRadius={12}
        padding="10px 12px"
        maxWidth="85%"
        marginBottom="-12px"
      >
        <Text fontSize="md" color="tints.black" whiteSpace="pre-wrap">
          {text}
        </Text>
      </Box>
    );
  }

  return (
    <Flex width="100%" justifyContent="flex-end" marginBottom="-12px">
      <Box
        display="flex"
        maxWidth={600}
        width="fit-content"
        minHeight={44}
        padding="12px 16px"
        flexDirection="column"
        justifyContent="center"
        alignItems="flex-end"
        borderRadius="22px 22px 0 22px"
        background="#E8E8E2"
      >
        <Text
          color="#0F0F0F"
          sx={{ fontFeatureSettings: "'liga' off, 'clig' off" }}
          fontFamily="DM Sans"
          fontSize="1rem"
          fontStyle="normal"
          fontWeight="400"
          lineHeight="150%"
          alignSelf="stretch"
          whiteSpace="pre-wrap"
        >
          {text}
        </Text>
      </Box>
    </Flex>
  );
}
